"use client";

import { useEffect } from "react";
import { registerFullScreenLoader } from "@/lib/e2e-readiness";

export default function FullScreenLoader({
  className,
  message,
}: {
  className?: string;
  message?: string;
}) {
  // While any full-screen loader is mounted the app isn't interactive; hold
  // the e2e-readiness sentinel until it unmounts. See lib/e2e-readiness.ts.
  useEffect(() => registerFullScreenLoader(), []);
  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm z-50 ${className}`}
    >
      <div className="w-20 h-20">
        <img src="/page-loader.svg" alt="loader" />
      </div>
      {message && (
        <span className="text-xs mt-4 text-center block text-gray-500 w-full">
          {message}
        </span>
      )}
    </div>
  );
}
